import React from 'react';
import classNames from 'classnames';

import { useIsMobile } from 'buyside/util/hooks/useIsMobile';

import ChevronRightIcon from 'buyside/svgs/chevron_right.svg';
import Icon from 'buyside/components/presentation/Icon/icon';

import styles from './filterExpandingStyles.scss';

const FilterExpanding: React.FC<{
  children: React.ReactNode;
  title: string;
  defaultCollapsed?: boolean;
  filterStyle?: any;
}> = ({ title, children, filterStyle, defaultCollapsed }): React.ReactElement => {
  const isMobile = useIsMobile();
  const [collapsed, setCollapsed] = React.useState(defaultCollapsed || isMobile);

  return (
    <div className={`${styles.filterArea} ${filterStyle ? filterStyle : ''}`}>
      <h5
        className={classNames(styles.filterTitle, { [styles.expanded]: !collapsed })}
        onClick={(): void => setCollapsed(!collapsed)}
      >
        <Icon type={ChevronRightIcon} className={styles.icon} />

        {title}
      </h5>

      {!collapsed && <div className={styles.childrenArea}>{children}</div>}
    </div>
  );
};

export default FilterExpanding;
